import { useAuth } from '../hooks/useAuth'
import { OnboardingProvider } from '../contexts/OnboardingContext'
import OnboardingWizard from '../components/onboarding/OnboardingWizard'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function Onboarding() {
  const { user, needsOnboarding, loading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    // If user is not authenticated, redirect to login
    if (!loading && !user) {
      navigate('/login')
      return
    }

    // If user doesn't need onboarding, redirect to dashboard
    if (!loading && user && !needsOnboarding) {
      navigate('/dashboard')
      return
    }
  }, [user, needsOnboarding, loading, navigate])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (!user || !needsOnboarding) {
    return null
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <OnboardingProvider>
        <OnboardingWizard />
      </OnboardingProvider>
    </div>
  )
}